module.exports = __webpack_public_path__ + "img/logo-kanggo-2.44148321.png";